/**
 * Pide confirmación antes de que la pestaña se cierre o se recargue mientras hay
 * algo en curso que no conviene cortar.
 *
 * El caso que lo motivó: recargar la página en medio de una grabación deja la
 * placa a medio borrar. El navegador le corta el puerto a esptool sin aviso, el
 * flash queda vacío, y la placa no arranca hasta que alguien la pone en modo
 * descarga a mano. Es recuperable, pero el usuario no tiene forma de saberlo.
 *
 * No bloquea nada: el navegador pregunta y el usuario decide. El texto lo elige
 * el navegador -- desde hace años ignoran el que se le pase -- así que acá solo
 * se marca el evento como cancelado, que es lo que dispara el cartel.
 *
 * Va como clase con target inyectable en vez de tocar window directamente para
 * que se pueda probar sin un DOM.
 */
class UnloadGuard {
  constructor(target) {
    this.target = target;
    this.active = false;
  }

  handle = (event) => {
    event.preventDefault();
    // Lo que de verdad dispara el cartel en los navegadores actuales. El string
    // es por compatibilidad con los viejos, que sí mostraban su contenido.
    event.returnValue = ''; // eslint-disable-line no-param-reassign
    return '';
  }

  set = (active) => {
    if (!this.target || active === this.active) return;
    this.active = active;
    if (active) this.target.addEventListener('beforeunload', this.handle);
    else this.target.removeEventListener('beforeunload', this.handle);
  }

  dispose = () => this.set(false)
}

export default UnloadGuard;
